module.exports = __webpack_public_path__ + "static/detecht-extraimg1-f8059253317f1e0d627fe05d89850c8f.png";